import { COHORT_TIER_KEY } from "~~/constants/discounts";
import { getLoyaltyLevelNumber } from "~~/helpers/getLoyaltyLevelNumber";
import { DEFAULT_LEVEL_FOR_USERS_WITH_NO_LEVEL } from "~~/constants/loyaltyProgram";

export default () => {

  const { customerTierKey } = useUserExtended();
  const { load: loadLoyaltyLevels, loyaltyLevels } = useCTLoyaltyLevels();

  const customerTierLoaded = computed(
    () => customerTierKey.value !== COHORT_TIER_KEY.NOT_LOGGED_IN,
  );

  const userLevelNumber = computed(() =>
    getLoyaltyLevelNumber(customerTierKey.value),
  );

  const currentUserLevelIndex = computed(() => {

    // user level number is 1-based, array is 0-based, so
    // need to adjust it by subtracting 1.
    return userLevelNumber.value === 0
      ? DEFAULT_LEVEL_FOR_USERS_WITH_NO_LEVEL
      : userLevelNumber.value - 1;

  });

  const currentLoyaltyLevel = computed(() => {

    if (
      customerTierLoaded.value &&
      loyaltyLevels.value &&
      loyaltyLevels.value[currentUserLevelIndex.value]
    ) {

      const level = loyaltyLevels.value[currentUserLevelIndex.value];

      return {
        levelNumber: level.levelNumber,
        spendingRange: level.spendingRange,
      };

    }

    return null;

  });

  return {
    customerTierLoaded,
    userLevelNumber,
    currentUserLevelIndex,
    currentLoyaltyLevel,
    loyaltyLevels,
    loadLoyaltyLevels,
  };

};
